module.exports = __webpack_public_path__ + "static/indexBg-6d0f9c0488db25dfd9356cfa0b4dfcd0.jpg";